---
meta:
  - title: Subir un expediente - IUSPRO Docs
  - description: Aprende a subir expedientes para análisis.
---

# Subir un expediente

Hay dos formas de subir un expediente para análisis. Ambas son fáciles de usar.

## Opción 1: Subir archivo PDF

Esta es la forma más directa:

1. **Haga clic en "Expediente nuevo"**
2. **Seleccione "Subir archivo PDF"**
3. **Suba su archivo PDF** con el expediente completo
4. **Indique qué parte representa**: Demandado o Demandante

Listo. El sistema procesará el expediente y le enviará un correo cuando termine.

## Opción 2: Usar credenciales del Sistema de Gestión en Línea

Esta opción es especialmente útil y **ahorra muchísimo tiempo**:

1. **Haga clic en "Expediente nuevo"**
2. **Seleccione usar credenciales del sistema**
3. **Ingrese su usuario y contraseña** del sistema de gestión en línea
4. **Ingrese el número del expediente**
5. **Indique qué parte representa**

### ¿Qué hace el sistema automáticamente?

Cuando usa esta opción, la plataforma:

1. Se loguea al sistema de gestión en línea con sus credenciales
2. Va a ese expediente específico
3. Descarga todos los documentos en orden
4. Los pega en un solo archivo PDF
5. Sube el PDF completo para análisis

**Esto de por sí ahorra muchísimo tiempo** que antes tenía que invertir descargando documentos uno por uno.

## Seguridad de las credenciales

**Importante**: Su usuario y contraseña **NO se guardan** en la plataforma.

Por motivos de seguridad, no almacenamos estos datos. Tiene que ingresarlos cada vez que quiera usar esta opción.

## Lista de expedientes

Todos los expedientes que suba quedan listados en la sección de Análisis de Expedientes. No va a perder ninguno.

## Créditos

Cada expediente que se sube cuenta como un crédito. Por eso es importante la función de compartir expedientes con otros usuarios (ver la guía de "Compartir expedientes") para que no gasten créditos por gusto.
